import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SEARCH_PARAMS_INTERNAL } from '../constants/auth';
import useGetConnectionType from '../hooks/useGetConnectionType';
import { useUserContext } from '../providers/UserProvider';
import { AUTH_TYPE } from '../types/auth';
import { handleBeforeUnload } from '../utils/leavePageWarning';
import { equalsIgnoreCase } from '../utils/stringUtils';

const popstateEventHandler = () => {
  window.history.pushState({ loggedIn: true }, '', window.location.href);
};

const preventBackNavigation = () => {
  // Replace the current state and add a new state to prevent going back
  window.history.replaceState({ loggedIn: true }, '', window.location.href);
  window.history.pushState({ loggedIn: true }, '', window.location.href);
  window.addEventListener('beforeunload', handleBeforeUnload);

  window.addEventListener('popstate', popstateEventHandler);
};

// Clean up function to remove event listeners
const cleanupNavigation = () => window.removeEventListener('beforeunload', handleBeforeUnload);

const UrlWatcher = () => {
  const { isAuthenticated, logout } = useAuth0();
  const location = useLocation();
  const currentUrl = useGetConnectionType();
  const { setUser, connectionType, setConnection } = useUserContext();

  const handleLogout = () => {
    const returnUrl = new URL(window.location.origin);

    if (currentUrl === AUTH_TYPE.Internal) {
      returnUrl.searchParams.append(SEARCH_PARAMS_INTERNAL, AUTH_TYPE.Internal);
    }

    setConnection(null);
    setUser(null);
    logout({ logoutParams: { returnTo: returnUrl.toString() } });
  };

  useEffect(() => {
    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }
    if (isAuthenticated) {
      preventBackNavigation();
      return () => {
        cleanupNavigation();
      };
    }
  }, [isAuthenticated, preventBackNavigation]);

  useEffect(() => {
    const monitorURL = () => {
      if (isAuthenticated && connectionType) {
        // Check if active connection and currentUrl are not the same value, then log user out from current scope
        if (
          (equalsIgnoreCase(connectionType, AUTH_TYPE.Internal) && !equalsIgnoreCase(currentUrl, AUTH_TYPE.Internal)) ||
          (equalsIgnoreCase(connectionType, AUTH_TYPE.External) && equalsIgnoreCase(currentUrl, AUTH_TYPE.Internal))
        ) {
          handleLogout();
        }
      }
    };

    monitorURL();
  }, [location, currentUrl, isAuthenticated, connectionType]);

  return null;
};

export default UrlWatcher;
